import { render, staticRenderFns } from "./GlobalNavigationBar.vue?vue&type=template&id=30b0c30c"
import script from "./GlobalNavigationBar.ts?vue&type=script&lang=ts&external"
export * from "./GlobalNavigationBar.ts?vue&type=script&lang=ts&external"
import style0 from "./GlobalNavigationBar.vue?vue&type=style&index=0&id=30b0c30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports